import debounce from 'lodash/debounce';
import { useRef, useCallback } from 'react';
// intentionally inferring the type here
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export var debounceWrapper = function (val, func, timeout) { return debounce(function () { return func(val); }, timeout); };
export var useDebounce = function (_a) {
    var debounceTimeout = _a.debounceTimeout, onDebounced = _a.onDebounced, cancelDebounce = _a.cancelDebounce;
    var staticDebounceCancelRef = useRef();
    var handleValueChange = useCallback(function (value) {
        var _a, _b;
        if (cancelDebounce === null || cancelDebounce === void 0 ? void 0 : cancelDebounce(value)) {
            (_a = staticDebounceCancelRef.current) === null || _a === void 0 ? void 0 : _a.call(staticDebounceCancelRef);
            return;
        }
        var debounceValue = debounceWrapper(value, onDebounced, debounceTimeout);
        debounceValue();
        // cancel previous debounce function
        (_b = staticDebounceCancelRef.current) === null || _b === void 0 ? void 0 : _b.call(staticDebounceCancelRef);
        // add reference to current debounce function
        staticDebounceCancelRef.current = debounceValue.cancel;
    }, [debounceTimeout, onDebounced, cancelDebounce]);
    return {
        handleValueChange: handleValueChange,
    };
};
//# sourceMappingURL=useDebounce.js.map